import { render, staticRenderFns } from "./RelLog.vue?vue&type=template&id=a79b2038&scoped=true"
import script from "./RelLog.vue?vue&type=script&lang=js"
export * from "./RelLog.vue?vue&type=script&lang=js"
import style0 from "./RelLog.vue?vue&type=style&index=0&id=a79b2038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79b2038",
  null
  
)

export default component.exports